import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import CheckBox from "./CheckBox";
import { lensesFamilyStore } from "../js/tableColumns";
import { LIMIT } from "../js/utils";
import DropdownFilter from "./DropdownFilter";
import ButtonIconH from "./ButtonIconH";
import GoDexLabelMultiplePopup from "./GoDexLabelMultiplePopup";

export default function LensesFamily({
  onSelectedProducts,
  products,
  onHandleLimit,
  onSeeMore,
  openProductPanel,
  createPopupQuestion,
  removePopupQuestion,
}) {
  const [selectedItems, setSelectedItems] = useState([]);
  const [productList, setProductList] = useState([]);
  const [limit, setLimit] = useState(LIMIT);
  const [goDexPopup, setGoDexPopup] = useState(false);
  const [directPrinting, setDirectPrinting] = useState(false);
  const [directPrintProduct, setDirectPrintProduct] = useState(null);

  const columns = lensesFamilyStore;

  const columnsWithInputs = columns.map((col) => {
    if (col.id === "code") {
      return {
        ...col,
        selector: (row) => (
          <button
            onClick={() => {
              setDirectPrintProduct(row);
              setDirectPrinting(true);
              setGoDexPopup(true);
            }}
          >
            <img
              src={"/images/code-blue.svg"}
              className="icon-pref"
              alt="Imprimir etiqueta"
            ></img>
          </button>
        ),
      };
    }
    if (col.id === "check") {
      return {
        ...col,
        selector: (row) => (
          <CheckBox
            active={selectedItems.some((e) => e.id === row.id)}
            onClick={() => handleCheckboxChange(row)}
          />
        ),
      };
    }

    return col;
  });

  function handleCheckboxChange(product) {
    setSelectedItems((prevSelected) =>
      prevSelected.some((e) => e.id === product.id)
        ? prevSelected.filter((element) => element.id !== product.id)
        : [...prevSelected, product],
    );
  }

  function handleSelectAll() {
    productList.map((e) => {
      setSelectedItems((prevSelected) =>
        prevSelected.some((element) => element.id === e.id)
          ? prevSelected
          : [...prevSelected, e],
      );
    });
  }

  function handleCleanSelected() {
    setSelectedItems([]);
  }

  const conditionalRowStyles = [
    {
      when: (row) => row.descatalogado,
      style: {
        backgroundColor: "#f0f0f0",
      },
    },
  ];

  useEffect(() => {
    setSelectedItems((prev) =>
      prev
        .filter((e) => productList.some((p) => p.id === e.id))
        .map((e) => productList.find((p) => p.id === e.id) ?? e),
    );
  }, [productList]);

  useEffect(() => {
    onSelectedProducts(selectedItems);
  }, [selectedItems]);

  useEffect(() => {
    setProductList(products);
  }, [products]);

  useEffect(() => {
    onHandleLimit(limit);
  }, [limit]);

  return (
    <div
      className="store-products-table"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
      }}
    >
      {goDexPopup && (
        <GoDexLabelMultiplePopup
          store={true}
          directPrinting={directPrinting}
          products={(directPrinting ? [directPrintProduct] : selectedItems).map((e) => ({
            ...e,
            pvp: e.PVP,
          }))}
          createPopupQuestion={createPopupQuestion}
          removePopupQuestion={removePopupQuestion}
          onClose={() => {
            setGoDexPopup(false);
            setDirectPrinting(false);
            setDirectPrintProduct(null);
          }}
        />
      )}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "5px",
          justifyContent: "flex-end",
          padding: "0 0 10px 0",
          width: "100%",
          alignItems: "center",
        }}
      >
        <div style={{ marginRight: 20 }}>
          <DropdownFilter
            disabled={false}
            optionList={[
              { id: "00", text: "25", active: limit === 25 },
              { id: "01", text: "50", active: limit === 50 },
              { id: "02", text: "100", active: limit === 100 },
            ]}
            op={"Mostrando " + limit}
            selectedOptions={[]}
            onChange={(e) => {
              setLimit(parseInt(e.text));
            }}
          ></DropdownFilter>
        </div>
        <button className="cell-label" onClick={handleSelectAll} tabIndex={-1}>
          Seleccionar todos
        </button>
        |
        <button
          className="cell-label"
          onClick={handleCleanSelected}
          tabIndex={-1}
        >
          Limpiar selección
        </button>
        <div style={{ marginLeft: 10 }}>
          <ButtonIconH
            disabled={selectedItems.length === 0}
            text={"Imprimir selección"}
            small={true}
            onClick={() => {
              setGoDexPopup(true);
            }}
          ></ButtonIconH>
        </div>
      </div>
      <DataTable
        columns={columnsWithInputs}
        data={productList}
        className="custom-datatable"
        noDataComponent="No hay productos disponibles."
        conditionalRowStyles={conditionalRowStyles}
        onRowClicked={(row) => {
          openProductPanel(row.codigo, true);
        }}
      />
      <div style={{ marginTop: 20 }}>
        <ButtonIconH
          text="Ver más"
          small={true}
          onClick={() => onSeeMore(limit)}
        ></ButtonIconH>
      </div>
    </div>
  );
}
